import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlternativeServiceOptions } from 'http2';
import { AlternateScoringModel } from 'src/app/clients-module/models/clientLocation';
import { ScoringModelMgrComponent } from 'src/app/clients-module/scoring-model-mgr/scoring-model-mgr.component';
import { AuthService } from 'src/app/services/auth.service';
import { RiqSliderV2Component } from '../riq-slider-v2/riq-slider-v2.component';
import { BehaviorSubject } from 'rxjs';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-scoring-model-list',
  templateUrl: './scoring-model-list.component.html',
  styleUrls: ['./scoring-model-list.component.less']
})
export class ScoringModelListComponent implements OnInit, AfterViewInit {
  availableScoringModels: AlternateScoringModel[];
  @Input() clientId: number;
  @Input() locationId: number;
  public get locked(): boolean {
    if(this.locationId > 0) return true;
    else return false;
  }

  public get scoringModels() : AlternateScoringModel[] {
    if(!this.availableScoringModels) return []
    return this.availableScoringModels;
  }

  constructor(public auth: AuthService, public modalService: NgbModal, public client: ClientService, public toastr: ToastrService) {
    
  }

  ngOnInit(): void {
    if(this.locationId > 0) {
      this.client.GetAlternativeScoringModelsByLocationId(this.locationId).pipe(tap((_: AlternateScoringModel[]) => {
        this.availableScoringModels = _;
      },
      err => {
        this.toastr.error("Could not load scoring models","", { closeButton: true, disableTimeOut: true });
      },
      () => {
  
      })).subscribe();
    }
    else {
      this.client.GetAlternativeScoringModels(this.clientId).pipe(tap((_: AlternateScoringModel[]) => {
        this.availableScoringModels = _;
      },
      err => {
        this.toastr.error("Could not load scoring models","", { closeButton: true, disableTimeOut: true });
      },
      () => {
  
      })).subscribe();
    }
  }

  ngAfterViewInit(): void {
    console.log(this.availableScoringModels);
  }

  public addNewScoringModel(): void {
    let newModel = new AlternateScoringModel();
    newModel.recDecAccept = 80;
    newModel.recDecConditionalHigh = 60;
    newModel.recDecConditionalLow = 40;
    newModel.clientId = this.clientId;
    newModel.scoringModelName = "Unsaved New Model";
    newModel.id = 0;
    newModel.clientId = this.clientId;

    this.availableScoringModels.push(newModel);
    this.editScoringModel(newModel);
  }

  public assignScoringModel(mod: AlternateScoringModel): void {
    const modalRef = this.modalService.open(ScoringModelMgrComponent, {centered: true, size: 'lg'});
    modalRef.componentInstance.name = 'scoringmdlmgr';
    modalRef.componentInstance.clientId = this.clientId;
    modalRef.componentInstance.modelId = mod.id;
    modalRef.componentInstance.modelName = mod.scoringModelName;
  }

  public editScoringModel(mod: AlternateScoringModel): void {
    const modalRef = this.modalService.open(RiqSliderV2Component, {centered: true, size: 'xl'});
    modalRef.componentInstance.name = 'slidermodelmgr';
    modalRef.componentInstance.altScoringModel = mod;
    modalRef.componentInstance.dismissed(() => {
      this.client.GetAlternativeScoringModels(this.clientId).pipe(tap((_:AlternateScoringModel[]) => {
        this.availableScoringModels = _;
      })).subscribe();
    })
  }

}
